import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allObjectStorage: [{}],
  objectStorage: {},
  newObjectStorage: {},
  updatedObjectStorage: {},
  deleteObjectStorage: {},
  wasabiAccounts: {},
  error: null,
};

const objectStorageSlice = createSlice({
  name: 'objectStorage',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.error;
    },
    setAllObjectStorage: (state, action) => {
      state.allObjectStorage = action.payload;
      state.error = null;
    },
    setObjectStorage: (state, action) => {
      state.objectStorage = action.payload;
      state.error = null;
    },
    setNewObjectStorage: (state, action) => {
      state.newObjectStorage = action.payload;
      state.error = null;
    },
    setUpdatedObjectStorage: (state, action) => {
      state.updatedObjectStorage = action.payload;
      state.error = null;
    },
    setDeleteObjectStorage: (state, action) => {
      state.deleteObjectStorage = action.payload;
      state.error = null;
    },
    setWasabiAccounts: (state, action) => {
      state.wasabiAccounts = action.payload;
      state.error = null;
    },
    setResetObjectStorage: () => {
      return initialState;
    },
  },
});

export const {
  setReducerError,
  setAllObjectStorage,
  setObjectStorage,
  setNewObjectStorage,
  setUpdatedObjectStorage,
  setDeleteObjectStorage,
  setWasabiAccounts,
  setResetObjectStorage,
} = objectStorageSlice.actions;

export default objectStorageSlice.reducer;
